/* eslint-disable spire/export-styles */
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { ProductListPageContext } from "@insite/content-library/Pages/ProductListPage";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import Modal, { ModalPresentationProps } from "@insite/mobius/Modal";
import React, { FC } from "react";
import { connect } from "react-redux";
import styled, { css } from "styled-components";

const mapStateToProps = (state: ApplicationState) => ({
    enableWarehousePickup: getSettingsCollection(state).accountSettings.enableWarehousePickup,
});

type Props = WidgetProps & ReturnType<typeof mapStateToProps>;

export interface ProductListMobileFilterStyle {
    filterModal?: ModalPresentationProps;
    filterButton?: ButtonPresentationProps;
}

export const mobileFilterStyle: ProductListMobileFilterStyle = {
    filterButton: {
        variant: "tertiary",
        css: css`
            width: 100%;
        `,
    },
};

const styles = mobileFilterStyle;

const FilterMobile: FC<Props> = ({ id }) => {
    const [isModalOpen, setIsModalOpen] = React.useState(false);

    const handleModalOpen = () => {
        setIsModalOpen(true);
    };
    const handleCloseModal = () => {
        setIsModalOpen(false);
    };

    return (
        <>
            <Modal
                headline={translate("Filter")}
                {...styles.filterModal}
                isOpen={isModalOpen}
                handleClose={handleCloseModal}
            >
                <Zone contentId={id} zoneName="content" />
            </Modal>
            <Button {...styles.filterButton} onClick={handleModalOpen}>
                {translate("Filter")}
            </Button>
        </>
    );
};

const filterMobile: WidgetModule = {
    component: connect(mapStateToProps)(FilterMobile),
    definition: {
        group: "Common",
        displayName: "Filter Mobile",
        icon: "Globe",
        allowedContexts: [ProductListPageContext],
    },
};

export default filterMobile;
